import { getHeaders, getKonnectHeaders, getMultipartHeaders } from '../common';

export const apiGet = async ({ endpoint, error_message }) => {
    try {
        const response = await fetch(endpoint, {
            method: "GET",
            headers: endpoint.indexOf("portal/konnekt") > 0 ? getKonnectHeaders() : getHeaders(),
            credentials: "include",
        });

        return await handleResponse(response, error_message);
    } catch (error) {
        console.error("API GET Error:", error);
        return { success: false, error: error_message };
    }
};

export const apiPost = async ({ endpoint, body, successMessage, errorMessage }) => {
    try {
        const response = await fetch(endpoint, {
            method: "POST",
            headers: endpoint.indexOf("portal/konnekt") > 0 ? getKonnectHeaders() : getHeaders(),
            body: JSON.stringify(body),
            credentials: "include",
        });

        const isJson = response.headers.get("content-type")?.includes("application/json");
        const data = isJson ? await response.json() : null;

        if (response.status === 400) {
            return {
                success: false,
                error: data?.error || data?.message || errorMessage,
                status: 400,
            };
        }

        if (!response.ok) {
            return {
                success: false,
                error: errorMessage || "Request failed",
                status: response.status,
            };
        }

        return {
            success: true,
            data,
            message: successMessage || "Created successfully",
        };
    } catch (error) {
        console.error("POST error:", error);
        return {
            success: false,
            error: errorMessage || "Failed to process request. Please contact the Carewindow team.",
        };
    }
};

export const apiPut = async ({ endpoint, body, successMessage, errorMessage }) => {
    try {
        const response = await fetch(endpoint, {
            method: "PUT",
            headers: endpoint.indexOf("portal/konnekt") > 0 ? getKonnectHeaders() : getHeaders(),
            body: JSON.stringify(body),
            credentials: "include",
        });

        const isJson = response.headers.get("content-type")?.includes("application/json");
        const data = isJson ? await response.json() : null;

        if (response.status === 400) {
            return {
                success: false,
                error: data?.error || data?.message || errorMessage,
                status: 400,
            };
        }

        if (!response.ok) {
            return {
                success: false,
                error: errorMessage || "Failed to update",
                status: response.status,
            };
        }

        return {
            success: true,
            data,
            message: successMessage || "Updated successfully",
        };
    } catch (error) {
        console.error("PUT error:", error);
        return {
            success: false,
            error: errorMessage || "Please check your network connection or refresh the page.",
        };
    }
};

export const apiPostMultipart = async ({ endpoint, formData, successMessage, errorMessage }) => {
    try {
        const response = await fetch(endpoint, {
            method: "POST",
            headers: getMultipartHeaders(),
            body: formData,
            credentials: "include",
        });

        const isJson = response.headers.get("content-type")?.includes("application/json");
        const data = isJson ? await response.json() : null;

        if (response.status === 400) {
            return {
                success: false,
                error: data?.detail || data?.error || data?.message || errorMessage,
                status: 400,
            };
        }

        if (!response.ok) {
            return {
                success: false,
                error: errorMessage || "Request failed",
                status: response.status,
            };
        }

        return {
            success: true,
            data,
            message: successMessage || "Created successfully",
        };
    } catch (error) {
        console.error("POST multipart error:", error);
        return {
            success: false,
            error: errorMessage || "Failed to upload. Please check your network connection.",
        };
    }
};

export const apiDelete = async ({ endpoint, successMessage, errorMessage }) => {
    try {
        const response = await fetch(endpoint, {
            method: "DELETE",
            headers: endpoint.indexOf("portal/konnekt") > 0 ? getKonnectHeaders() : getHeaders(),
            credentials: "include",
        });

        if (!response.ok) {
            return {
                success: false,
                message: errorMessage || response.statusText || "Failed to delete resource",
                status: response.status,
            };
        }

        return {
            success: true,
            message: successMessage || "Deleted successfully",
        };
    } catch (error) {
        console.error("DELETE error:", error);
        return {
            success: false,
            message: errorMessage || "Failed to delete. Please refresh the page or check your network connection.",
        };
    }
};

const handleResponse = async (response, error_message) => {
    const contentType = response.headers.get("content-type");

    let data = null;
    if (contentType && contentType.includes("application/json")) {
        data = await response.json();
    }

    if (!response.ok) {
        return {
            success: false,
            error: error_message || data?.message || response.statusText || "Request failed",
            status: response.status
        };
    }

    return { success: true, data };
};